import React from 'react'
import agent from '../agent'
import { connect } from 'react-redux'
import { store } from '../store'
import { push } from 'react-router-redux'
import ListErrors from './ListErrors'
import {
    REGISTER,
    REGISTER_PAGE_UNLOADED,
    REDIRECT
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'
import { Link } from 'react-router-dom'
const mapStateToProps = state => ({
    ...state.auth,
    redirectTo: state.common.redirectTo,
    inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
    onSubmit: (payload) =>
        dispatch({ type: REGISTER, payload }),
    onRedirect: () =>
        dispatch({ type: REDIRECT }),
    onUnload: () => dispatch({ type: REGISTER_PAGE_UNLOADED })
})

class Register extends React.Component {
    constructor() {
        super()
        this.state = {
            firstname: '',
            lastname: '',
            email: '',
            phone: '',
            password: '',
            referrer: ''
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (firstname, lastname, phone, email, password, referrer) => ev => {
            ev.preventDefault()
            const payload = agent.Auth.register(firstname, lastname, phone, email, password, referrer, true)
            this.props.onSubmit(payload)
        }
    }
    componentWillMount() {
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            store.dispatch(push(nextProps.redirectTo))
            this.props.onRedirect()
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        const firstname = this.state.firstname || "";
        const lastname = this.state.lastname || "";
        const phone = this.state.phone || "";
        const email = this.state.email || "";
        const password = this.state.password || "";
        const referrer = this.state.referrer || ""
        const inProgress = this.props.inProgress;
        return (
            <div id="focus">
                <div id="main">
                    <div id="main-wrap">
                        <div id="focus-wrap">
                            <h2>Account Registration</h2>
                            <div className="FormItem">
                                <label>First name</label>
                                <input type="text" placeholder="Jackie" value={firstname} onChange={this.updateState('firstname')} />
                            </div>
                            <div className="FormItem">
                                <label>Last name</label>
                                <input type="text" placeholder="Chan" value={lastname} onChange={this.updateState('lastname')} />
                            </div>
                            <div className="FormItem">
                                <label>Phone</label>
                                <input type="text" placeholder="+60100000000" value={phone} onChange={this.updateState('phone')} />
                            </div>
                            <div className="FormItem">
                                <label>Email</label>
                                <input type="text" placeholder="jackie.chan@gmail.com" value={email} onChange={this.updateState('email')} />
                            </div>
                            <div className="FormItem">
                                <label>Password</label>
                                <input type="password" value={password} onChange={this.updateState('password')} />
                            </div>
                            <ListErrors errors={this.props.errors} />
                            <div className="FormItem">
                                <button onClick={this.submitForm(firstname, lastname, phone, email, password, referrer)}>{this.props.inProgress ? 'Registering...' : 'Register'}</button>
                            </div>
                            <div className="FormItem">
                                <Link to="/login"> <em>Login Here</em></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)
